/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface IArgs {
  isGeneratingDraft?: boolean;
  generatingLabel?: string;
  messageAreaClass?: string;
  showInfoRow?: boolean;
  showDraftButton?: boolean;
  draftButtonDisabled?: boolean;
  draftButtonLabel?: string;
  onGenerateDraft: () => void;
  showSendButton?: boolean;
  hasContent?: boolean;
  isSubmitDisabled?: boolean;
  onSubmit: () => void;
}

interface ComposerSignature {
  Element: HTMLDivElement;

  Args: IArgs;

  Blocks: {
    before?: [];
    input: [];
    infoLeft?: [];
    infoRight?: [];
    after?: [];
    footerLeft?: [];
    footerRight?: [];
  };
}

export default class UiMessagesComposerComponent extends Component<ComposerSignature> {
  get showInfoRow(): boolean {
    return this.args.showInfoRow ?? true;
  }

  get showSendButton(): boolean {
    return this.args.showSendButton ?? true;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Messages::Composer': typeof UiMessagesComposerComponent;
  }
}
